export const errorCode: { [key: number]: string } = {
  900: "You do not have permission to perform this action. Please contact your Varaha representative",
  901: "Permission Error",
  999: "Something went wrong",
  1210: "Validation Failure",
  2001: "Matching User does not exist",
  2002: "User is Marked InActive. Please Contact Admin/Manager.",
  2100: "Invalid Output Data",
  2101: "Invalid Start Date Or End Date.",
  2501: "Service Unavailable. Please Try Later.",
  2102: "Do not have Permission to login,Please contact Varaha Admin",
  2103: "Invalid Username or Password.",
  2104: "Google SignIn Failed.",
  2105: "Google SignIn Failed.",
  2106: "Failed to login due to unexpected error.",
  1100: "Invalid Header",
  1152: "User-Client-Tenant Mismatch",
  // User profile
  4001: "Something went wrong", //changed
  4002: "The email address provided does not correspond to an active user account.",
  4003: "Invalid reset password link.",
  4004: "The reset password link has expired.",
  4005: "Password and Confirm passwords do not match.", //changed
  4006: "Please enter a valid Aadhaar number..", //changed
  4007: "Please enter a valid email.", //changed
  4008: "Please enter a valid phone number.", //changed
  4009: "User doesn't exist,please contact Varaha admin", //changed
  4010: "Invalid password. Must be 8+ Characters, contain letters,numbers ,special characters and starts with capital letter and should not be same as username", //changed
  //  Manage Surveyor
  3001: "Something went wrong,Please contact Varaha admin", //changed
  3002: "Sorry, we couldn't find the manager's email.", //changed
  3003: "Surveyor is Invalid or Inactive.", //changed
  3004: "No surveyor Deactivation entry found.", //changed
  3005: "The surveyor has already been deactivated.", //changed
  3006: "Please provide a valid surveyor detail", //changed
  3007: "Invalid OTP for Surveyor Deactivation process,Please try with valid OTP", //changed
  3008: "The OTP provided has expired. Kindly request a new OTP to continue with the Surveyor Deactivation.", //changed
  3009: "Please provide a valid otp and uuid", //changed
  3010: "Please provide a valid block, district, state and country details.", //changed
  3011: "The surveyor has already been created.", //changed
  3012: "No Surveyor Registration entry found", //changed
  3014: "Sorry, no registration found with that OTP. Please try again.", //changed
  3016: "The OTP provided has expired. Kindly request a new OTP to continue with the Surveyor Registration.", //changed
  3017: "User does not belong to any project.", //changed
  3018: "User does not belong to any odk forms.", //changed
  3019: "Something went wrong",
};
